import { render, staticRenderFns } from "./ed-tabs.vue?vue&type=template&id=48954912&scoped=true&"
import script from "./ed-tabs.ts?vue&type=script&lang=ts&"
export * from "./ed-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./ed-tabs.scss?vue&type=style&index=0&id=48954912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48954912",
  null
  
)

export default component.exports